import Page from "webPage/Page";
import URLHelper from "base/URLHelper";

Page.register('single-post', () => {
    let $articleContent = $('.js-article-content');
    let article_content_h2 = $articleContent.find("h2");

    if(article_content_h2.length > 1){
        $('.js-news-article-layout').removeClass('article--full').find('.article__contents').show();
        article_content_h2.each(function(index, element){
            createLink(element);
        });
    }
    });





function createLink(element) {
    let heading_text = $(element).text();
    let span_id = generateIdToUse(heading_text);

    $(".js-content-list").append((
        eotwJSXFactory('li', {className: "contents-list__list-item"}, [eotwJSXFactory('a', {href: '#' + span_id, className: "contents-list__list-link js-toc-link"}, [heading_text])])
    ));

    $(element).replaceWith(buildElement(heading_text, span_id));
}

function generateIdToUse(heading_text) {
    let base_id = URLHelper.slug(heading_text);
    let id = base_id;

    let i = 1;

    do {
        if ($("#" + id).length === 0) {
            return id;
        }

        id = base_id + '-' + i;
    } while (i++ <= 500);

    return base_id + '-' + Math.random();
}

function buildElement(heading_text, span_id) {
    return (
        eotwJSXFactory('h2', null, [
            eotwJSXFactory('span', {id: span_id}, [heading_text])
        ])
    );
}
